import { render, staticRenderFns } from "./CollapseList.vue?vue&type=template&id=561d9702&scoped=true"
import script from "./CollapseList.vue?vue&type=script&lang=js"
export * from "./CollapseList.vue?vue&type=script&lang=js"
import style0 from "./CollapseList.vue?vue&type=style&index=0&id=561d9702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561d9702",
  null
  
)

export default component.exports